<div class="container-fluid" id="container-wrapper" style="background-color: white;padding: 5px;" *ngIf="userType=='Admin' || userType=='Counsellor'">

    <div class="d-sm-flex align-items-center justify-content-between mb-4" style="border-bottom:2px solid grey;">
        <h1 class="h3 mb-0 text-gray-800" style="margin-top: 0px;padding-bottom:5px;">Bulk Re-Assign Leads</h1>
    </div>

    <div class="row" style="margin-bottom: 2px;background-color: rgb(248, 247, 247);margin-top: -10px;">
        <mat-form-field class="col-sm-2">
            <input matInput type="date" name="fromDate" [(ngModel)]="leadFilter.fromDate" placeholder="From Date" [min]="fromDate">
        </mat-form-field>
        <mat-form-field class="col-sm-2">
            <input matInput type="date" name="toDate" [(ngModel)]="leadFilter.toDate" placeholder="To Date" [min]="fromDate">
        </mat-form-field>

        <mat-form-field class="col-sm-2">
            <mat-select class="field-full-width" placeholder="Lead Status" [(ngModel)]="leadFilter.status">
                <mat-option value="All">All</mat-option>
                <mat-option *ngFor="let stat of listStatus" [value]="stat">{{stat}}</mat-option>
            </mat-select>

        </mat-form-field>
        <mat-form-field class="col-sm-2">

            <mat-select class="field-full-width" placeholder="Lead Sub-Status" [(ngModel)]="leadFilter.subStatus">
                <mat-option value="All">All</mat-option>
                <mat-option *ngFor="let stat of listSubStatus" [value]="stat">{{stat}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="col-sm-2">
            <mat-select class="field-full-width" placeholder="State" [(ngModel)]="leadFilter.state">
                <mat-option value="All">All</mat-option>
                <mat-option *ngFor="let stat of listState" [value]="stat">{{stat}}</mat-option>
            </mat-select>

        </mat-form-field>
        <mat-form-field class="col-sm-2">
            <mat-select class="field-full-width" placeholder="City" [(ngModel)]="leadFilter.city">
                <mat-option value="All">All</mat-option>
                <mat-option *ngFor="let stat of listCity" [value]="stat">{{stat}}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="col-sm-4">
            <mat-select class="field-full-width" placeholder="Counsellor" [(ngModel)]="leadFilter.assignedTo">
                <mat-option value="All">All</mat-option>
                <mat-option *ngFor="let stat of listCounsellor" [value]="stat.name">{{stat.name}}</mat-option>
            </mat-select>

        </mat-form-field>
        <mat-form-field class="col-sm-4">
            <mat-select class="field-full-width" placeholder="Source" [(ngModel)]="leadFilter.leadSource">
                <mat-option value="All">All</mat-option>
                <mat-option *ngFor="let stat of listSource" [value]="stat">{{stat}}</mat-option>
            </mat-select>
        </mat-form-field>
        <div class="col-sm-2">
            <button type="button" class="btn btn-primary block" style="width: 100%;" (click)="filterLeads();">View Leads</button>
        </div>
        <div class="col-sm-2">
            <button type="button" style="float: inline-end;width: 100%;" class="btn btn-primary block" (click)="checkBoxClicked();">Re-Assign</button>

        </div>
    </div>



    <table class="table table-sm" style="padding-right: 20px!important;margin-top: 0px;font-size: small;padding: 0;height: 100px;overflow-y: scroll;" *ngIf="filterClicked">
        <tr class="thead-dark">

            <th style="max-width: 15px;">#</th>
            <th>
                <input type="checkbox" [checked]="selectAllCheckbox" (change)="selectAll($event)">
            </th>
            <th>Student Details</th>
            <th *ngIf="!androidOs">Address</th>
            <th>Lead Status</th>
            <th *ngIf="!androidOs">Other Details</th>
        </tr>
        <tbody id="myTable">
            <tr *ngFor="let item of pagedItems;let counter=index;">
                <td>{{counter+1}}</td>
                <td><input type="checkbox" [value]="item.refNo" [checked]="isLeadSelected(item.refNo)" (change)="toggleLeadSelection(item.refNo, $event.target.checked)"></td>
                <td><b>Name : </b>{{item.studentName}}<br><b>Mobile : </b>{{item.mobileNo}}
                    <br><b>EMail : </b>{{item.emailId}}</td>
                <td *ngIf="!androidOs"><b>Address : </b>{{item.address}}<br><b>City : </b>{{item.cityName}}<br><b>State : </b>{{item.stateName}}</td>
                <td><b>Assigned To :</b> {{item.assignToCounsellor}}<br><b>Status : </b>{{item.status}}</td>
                <td *ngIf="!androidOs"><b>On Date : </b>{{item.leadDate}}<br><b>Source : </b>{{item.source}}<br><b>Program : </b> {{item.courseName}}</td>
            </tr>
        </tbody>
    </table>
    <div class="pagination-wrapper">
        <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
            <li [ngClass]="{disabled:pager.currentPage === 1}">
                <a (click)="setPage(1)">First</a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === 1}">
                <a (click)="setPage(pager.currentPage - 1)">Prev</a>
            </li>
            <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                <a (click)="setPage(page)">{{page}}</a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                <a (click)="setPage(pager.currentPage + 1)">Next</a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                <a (click)="setPage(pager.totalPages)">Last</a>
            </li>
        </ul>
    </div>


</div>